import axios from "axios";

import {
  authHeader,
  refreshHeader,
  hasRefreshTokenExpired,
  hasTokenExpired,
} from "../helper/auth-header";

export const userService = {
  login,
  logout,
  post,
  getJson,
  getFile,
  postFile,
  put,
};

function login(email, password) {
  const requestOptions = {
    headers: { "Content-Type": "application/json" },
  };
  return axios
    .post(`user/login`, JSON.stringify({ email, password }), requestOptions)
    .then(response => {
      // login successful if there's a jwt token in the response
      if (response.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    })
    .catch(handleResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

function post(path, data) {
  if (hasTokenExpired() && !hasRefreshTokenExpired()) {
    const requestRefreshOptions = {
      headers: refreshHeader(),
    };
    return axios
      .get(`user/refresh`, requestRefreshOptions)
      .then(response => {
        // refresh successful if there's a jwt token in the response
        if (response.data.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(response.data));
          const updatedRequestOptions = {
            headers: { ...authHeader(), "Content-Type": "application/json" },
          };
          return axios
            .post(`${path}`, JSON.stringify(data), updatedRequestOptions)
            .then(response => {
              return response.data;
            })
            .catch(handleResponse);
        }
        return response.data;
      })
      .catch(handleResponse);
  } else {
    const requestOptions = {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    };

    return axios
      .post(`${path}`, JSON.stringify(data), requestOptions)
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  }
}

function getJson(path) {
  if (hasTokenExpired() && !hasRefreshTokenExpired()) {
    const requestRefreshOptions = {
      headers: refreshHeader(),
    };
    return axios
      .get(`user/refresh`, requestRefreshOptions)
      .then(response => {
        // refresh successful if there's a jwt token in the response
        if (response.data.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(response.data));
          const updatedRequestOptions = {
            headers: authHeader(),
          };
          return axios
            .get(`${path}`, updatedRequestOptions)
            .then(response => {
              return response.data;
            })
            .catch(handleResponse);
        }
        return response.data;
      })
      .catch(handleResponse);
  } else {
    const requestOptions = {
      headers: authHeader(),
    };

    return axios
      .get(`${path}`, requestOptions)
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  }
}

function postFile(path, data) {
  var body = JSON.stringify(data);

  if (hasTokenExpired() && !hasRefreshTokenExpired()) {
    const requestRefreshOptions = {
      headers: refreshHeader(),
    };

    return axios
      .get(`user/refresh`, requestRefreshOptions)
      .then(response => {
        if (response.data.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(response.data));
          const updatedRequestOptions = {
            headers: { ...authHeader(), "Content-Type": "application/json" },
            responseType: "blob",
          };
          return axios
            .post(`${path}`, body, updatedRequestOptions)
            .then(response => {
              return response.data;
            })
            .catch(handleResponse);
        }
        return response.data;
      })
      .catch(handleResponse);
  } else {
    const requestOptions = {
      headers: { ...authHeader(), "Content-Type": "application/json" },
      responseType: "blob",
    };

    return axios
      .post(`${path}`, body, requestOptions)
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  }
}

function getFile(path) {
  if (hasTokenExpired() && !hasRefreshTokenExpired()) {
    const requestRefreshOptions = {
      method: "GET",
      headers: refreshHeader(),
    };
    return axios
      .get(`user/refresh`, requestRefreshOptions)
      .then(response => {
        // refresh successful if there's a jwt token in the response
        if (response.data.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(response.data));
          const updatedRequestOptions = {
            method: "GET",
            headers: authHeader(),
            responseType: "blob",
          };
          return axios
            .get(`${path}`, updatedRequestOptions)
            .then(response => {
              return response.data;
            })
            .catch(handleResponse);
        }
        return response.data;
      })
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  } else {
    const requestOptions = {
      headers: authHeader(),
      responseType: "blob",
    };

    return axios
      .get(`${path}`, requestOptions)
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  }
}

function put(path, data) {
  if (hasTokenExpired() && !hasRefreshTokenExpired()) {
    const requestRefreshOptions = {
      headers: refreshHeader(),
    };
    return axios
      .get(`user/refresh`, requestRefreshOptions)
      .then(response => {
        // refresh successful if there's a jwt token in the response
        if (response.data.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(response.data));
          const updatedRequestOptions = {
            headers: { ...authHeader(), "Content-Type": "application/json" },
          };
          return axios
            .put(`${path}`, JSON.stringify(data), updatedRequestOptions)
            .then(response => {
              return response.data;
            })
            .catch(handleResponse);
        }
        return response.data;
      })
      .catch(handleResponse);
  } else {
    const requestOptions = {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    };

    return axios
      .put(`${path}`, JSON.stringify(data), requestOptions)
      .then(response => {
        return response.data;
      })
      .catch(handleResponse);
  }
}

function handleResponse(error) {
  if (error.response && error.response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    if (location.pathname != "login") {
      location.reload(true);
    }
  }
  if (error.response && error.response.data) {
    return Promise.reject(error.response.data.message);
  } else if (error.response && error.response.statusText) {
    return Promise.reject(error.response.statusText);
  } else if (error.request) {
    return Promise.reject("Network Error: server did not respond");
  } else if (error.message) {
    return Promise.reject(error.message);
  } else {
    return Promise.reject(error);
  }
}
